import React, { useState, useEffect, useRef, useContext } from "react";

import * as Yup from "yup";
import { Formik, FieldArray, Form, Field } from "formik";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CircularProgress from "@material-ui/core/CircularProgress";
import Compressor from "compressorjs";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import {
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import {
  AccessTime,
  AddCircle,
  Delete,
  Image,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Message,
  MicNone,
  Videocam,
  InsertDriveFile,
  TouchApp,
  List as ListIcon,
} from "@mui/icons-material";
import { capitalize } from "../../utils/capitalize";
import { Box } from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },

  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  btnWrapper: {
    position: "relative",
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const FlowBuilderSingleBlockModal = ({
  open,
  onSave,
  onUpdate,
  data,
  close,
}) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);

  const [rule, setRule] = useState();

  const [medias, setMedias] = useState([]);

  const [textDig, setTextDig] = useState();

  const [elements, setElements] = useState([]);

  const [elementsSeq, setElementsSeq] = useState([]);

  const [elementsSeqEdit, setElementsSeqEdit] = useState([]);

  const [elementsEdit, setElementsEdit] = useState([]);

  const [numberMessages, setNumberMessages] = useState(0);

  const [numberMessagesLast, setNumberMessagesLast] = useState(0);

  const [numberInterval, setNumberInterval] = useState(0);

  const [numberIntervalLast, setNumberIntervalLast] = useState(0);

  const [numberAudio, setNumberAudio] = useState(0);

  const [numberAudioLast, setNumberAudioLast] = useState(0);

  const [numberVideo, setNumberVideo] = useState(0);

  const [numberVideoLast, setNumberVideoLast] = useState(0);

  const [numberImg, setNumberImg] = useState(0);

  const [numberImgLast, setNumberImgLast] = useState(0);

  const [loading, setLoading] = useState(false);

  const [previewImg, setPreviewImg] = useState([]);

  const [previewAudios, setPreviewAudios] = useState([]);

  const [previewVideos, setPreviewVideos] = useState([]);

  const [arrayOption, setArrayOption] = useState([]);

  const [variables, setVariables] = useState([]);

  const [previewDocs, setPreviewDocs] = useState([]);
  const [numberDocLast, setNumberDocLast] = useState(0);
  const [numberDocs, setNumberDocs] = useState(0);

  const [numberButton, setNumberButton] = useState(0);
  const [numberButtonLast, setNumberButtonLast] = useState(0);
  const [numberList, setNumberList] = useState(0);
  const [numberListLast, setNumberListLast] = useState(0);

  // Estado para botão/lista (evita ler do DOM e garante que arrayOption/sections sejam salvos)
  const [buttonListFormState, setButtonListFormState] = useState({});
  const buttonListFormStateRef = useRef(buttonListFormState);
  buttonListFormStateRef.current = buttonListFormState;
  const setButtonListFormStateAndRef = (key, next) => {
    setButtonListFormState((prev) => ({ ...prev, [key]: next }));
    buttonListFormStateRef.current = { ...buttonListFormStateRef.current, [key]: next };
  };

  const [labels, setLabels] = useState({
    title: "Adicionar conteúdo ao fluxo",
    btn: "Adicionar",
  });

  const { user } = useContext(AuthContext);

  const companyId = user.companyId;

  const handleElements = (newNameFiles) => {
    let elementsSequence = [];

    const newArrMessage = elementsSeq.filter((item) =>
      item.includes("message")
    );
    const newArrInterval = elementsSeq.filter((item) =>
      item.includes("interval")
    );
    const newArrImg = elementsSeq.filter((item) => item.includes("img"));
    const newArrAudio = elementsSeq.filter((item) => item.includes("audio"));
    const newArrVideo = elementsSeq.filter((item) => item.includes("video"));
    const newArrButton = elementsSeq.filter((item) => item.includes("button"));
    const newArrList = elementsSeq.filter((item) => item.includes("list"));

    //Todas as mensagens
    for (let i = 0; i < numberMessages; i++) {
      const value = document
        .querySelector(`.${newArrMessage[i]}`)
        .querySelector(".MuiInputBase-input").value;
      if (!value) {
        toast.error("Campos de mensagem vazio!");
        setLoading(false);
        throw "";
      }
      elementsSequence.push({
        type: "message",
        value: value,
        number: newArrMessage[i],
      });
      console.log("text");
    }
    //Todos os intervalos
    for (let i = 0; i < numberInterval; i++) {
      const value = document
        .querySelector(`.${newArrInterval[i]}`)
        .querySelector(".MuiInputBase-input").value;
      if (parseInt(value) === 0 || parseInt(value) > 120) {
        toast.error("Intervalo não pode ser 0 ou maior que 120!");
        setLoading(false);
        throw "";
      }
      elementsSequence.push({
        type: "interval",
        value: value,
        number: newArrInterval[i],
      });
    }

    //Todas as imagens
    for (let i = 0; i < numberImg; i++) {
      const onlyImg =
        newNameFiles !== null &&
        newNameFiles.filter(
          (file) =>
            file.includes("png") ||
            file.includes("jpg") ||
            file.includes("jpeg")
        );
      const onlyImgNameOriginal = medias.filter(
        (file) =>
          file.name.includes("png") ||
          file.name.includes("jpg") ||
          file.name.includes("jpeg")
      );
      if (elementsSeqEdit.includes(newArrImg[i])) {
        const itemSelectedEdit = elementsEdit.filter(
          (item) => item.number === newArrImg[i]
        )[0];
        elementsSequence.push({
          type: "img",
          value: itemSelectedEdit.value,
          original: itemSelectedEdit.original,
          number: itemSelectedEdit.number,
          teste: "image",
        });
      } else {
        let indexElem = 0;
        if (elementsSeqEdit.filter((item) => item.includes("img")).length > 0) {
          indexElem =
            elementsSeqEdit.filter((item) => item.includes("img")).length - i;
        } else {
          indexElem = i;
        }

        // console.log("IMAGE", indexElem, '-->>', onlyImgNameOriginal[indexElem]);

        elementsSequence.push({
          type: "img",
          value: onlyImg[indexElem],
          original: onlyImgNameOriginal[indexElem].name,
          number: newArrImg[i],
          teste: "image",
        });
      }
    }
    //Todos os audios
    for (let i = 0; i < numberAudio; i++) {
      const onlyAudio =
        newNameFiles !== null &&
        newNameFiles.filter(
          (file) =>
            file.includes("mp3") ||
            file.includes("ogg") ||
            file.includes("mpeg") ||
            file.includes("opus")
        );
      const onlyAudioNameOriginal = medias.filter(
        (file) =>
          file.name.includes("mp3") ||
          file.name.includes("ogg") ||
          file.name.includes("mpeg") ||
          file.name.includes("opus")
      );

      if (elementsSeqEdit.includes(newArrAudio[i])) {
        const itemSelectedEdit = elementsEdit.filter(
          (item) => item.number === newArrAudio[i]
        )[0];
        elementsSequence.push({
          type: "audio",
          value: itemSelectedEdit.value,
          original: itemSelectedEdit.original,
          number: itemSelectedEdit.number,
          record: document
            .querySelector(`.check${newArrAudio[i]}`)
            .querySelector(".PrivateSwitchBase-input").checked,
        });
      } else {
        let indexElem = 0;
        if (
          elementsSeqEdit.filter((item) => item.includes("audio")).length > 0
        ) {
          indexElem =
            elementsSeqEdit.filter((item) => item.includes("audio")).length - i;
        } else {
          indexElem = i;
        }
        elementsSequence.push({
          type: "audio",
          value: onlyAudio[indexElem],
          original: onlyAudioNameOriginal[indexElem].name,
          number: newArrAudio[i],
          record: document
            .querySelector(`.check${newArrAudio[i]}`)
            .querySelector(".PrivateSwitchBase-input").checked,
        });
      }
    }
    //Todos os videos
    for (let i = 0; i < numberVideo; i++) {
      const onlyVideo =
        newNameFiles !== null &&
        newNameFiles.filter(
          (file) => file.includes("mp4") || file.includes("avi")
        );
      const onlyVideoNameOriginal = medias.filter(
        (file) => file.name.includes("mp4") || file.name.includes("avi")
      );
      if (elementsSeqEdit.includes(newArrVideo[i])) {
        const itemSelectedEdit = elementsEdit.filter(
          (item) => item.number === newArrVideo[i]
        )[0];
        elementsSequence.push({
          type: "video",
          value: itemSelectedEdit.value,
          original: itemSelectedEdit.original,
          number: itemSelectedEdit.number,
        });
      } else {
        let indexElem = 0;
        if (
          elementsSeqEdit.filter((item) => item.includes("video")).length > 0
        ) {
          indexElem =
            elementsSeqEdit.filter((item) => item.includes("video")).length - i;
        } else {
          indexElem = i;
        }
        elementsSequence.push({
          type: "video",
          value: onlyVideo[indexElem],
          original: onlyVideoNameOriginal[indexElem].name,
          number: newArrVideo[i],
        });
      }
    }
    // Todos os documentos
    for (let i = 0; i < numberDocs; i++) {
      const onlyDocs =
        newNameFiles !== null &&
        newNameFiles.filter((file) => file.includes("pdf"));
      const onlyDocNameOriginal = medias.filter((file) =>
        file.name.includes("pdf")
      );

      // console.log("### elementsSeqEdit", elementsSeqEdit);

      if (elementsSeqEdit.includes(`document${i}`)) {
        const itemSelectedEdit = elementsEdit.filter(
          (item) => item.number === `document${i}`
        )[0];
        elementsSequence.push({
          type: "document",
          value: itemSelectedEdit?.value,
          original: itemSelectedEdit?.original,
          number: itemSelectedEdit?.number,
        });
      } else {
        let indexElem = 0;
        if (
          elementsSeqEdit.filter((item) => item.includes("document")).length > 0
        ) {
          indexElem =
            elementsSeqEdit.filter((item) => item.includes("document")).length -
            i;
        } else {
          indexElem = i;
        }

        // console.log("onlyDocs", onlyDocs);
        // console.log("onlyDocNameOriginal", onlyDocNameOriginal);
        // console.log("DOCUMENT", indexElem, '-->>', onlyDocNameOriginal[indexElem]);

        elementsSequence.push({
          type: "document",
          value: onlyDocs[indexElem],
          original: onlyDocNameOriginal[indexElem].name,
          number: `document${i}`,
        });
      }
    }

    // Helper: fallback DOM (MUI aplica className no wrapper)
    const getInputValue = (selector) => {
      const el = document.querySelector(selector);
      if (!el) return "";
      const input = el.matches?.("input, textarea") ? el : el.querySelector?.("input, textarea");
      return (input?.value ?? "").trim();
    };

    // Botões: usar estado quando existir (ref para evitar closure desatualizada no setTimeout)
    const latestState = buttonListFormStateRef.current || {};
    for (let i = 0; i < newArrButton.length; i++) {
      const key = newArrButton[i];
      const st = latestState[key];
      let message, arrayOption;
      if (st != null) {
        message = (st.message || "").trim();
        const optsArr = st.opts && Array.isArray(st.opts) ? st.opts : [""];
        arrayOption = optsArr
          .map((val, idx) => ({ number: idx + 1, value: String(val != null ? val : "").trim().substring(0, 20) }))
          .filter((o) => o && o.value);
      } else {
        const num = key.replace("button", "");
        message = getInputValue(`.buttonMessage${num}`);
        arrayOption = [1, 2, 3]
          .map((idx) => ({ number: idx, value: getInputValue(`.buttonOpt${num}-${idx}`).substring(0, 20) }))
          .filter((o) => o && o.value);
      }
      elementsSequence.push({ type: "button", number: key, value: message, arrayOption });
    }

    // Lista: usar estado quando existir (ref para evitar closure desatualizada)
    for (let i = 0; i < newArrList.length; i++) {
      const key = newArrList[i];
      const st = latestState[key];
      let message, buttonText, sectionTitle, rows;
      if (st != null) {
        message = (st.message || "").trim();
        buttonText = (st.buttonText || "").trim() || "Escolha uma opção";
        sectionTitle = (st.sectionTitle || "").trim() || "Opções";
        rows = (st.rows || []).filter((r) => r && (String(r.id || "").trim() || String(r.title || "").trim())).map((r) => ({ id: String(r.id || "").trim(), title: String(r.title || "").trim().substring(0, 24) }));
      } else {
        const num = key.replace("list", "");
        message = getInputValue(`.listMessage${num}`);
        buttonText = getInputValue(`.listButtonText${num}`) || "Escolha uma opção";
        sectionTitle = getInputValue(`.listSectionTitle${num}`) || "Opções";
        rows = [];
        for (let r = 0; r < 10; r++) {
          const id = getInputValue(`.listRowId${num}-${r}`);
          const title = getInputValue(`.listRowTitle${num}-${r}`);
          if (id || title) rows.push({ id: id.trim(), title: title.substring(0, 24) });
        }
      }
      elementsSequence.push({
        type: "list",
        number: key,
        value: message,
        buttonText,
        sections: rows.length ? [{ title: sectionTitle.substring(0, 24), rows }] : [],
      });
    }

    return elementsSequence;
  };

  const deleteElementsTypeOne = (id, type) => {
    if (type === "message") {
      setNumberMessages((old) => old - 1);
      setElementsSeq((old) => old.filter((item) => item !== `message${id}`));
      setElementsSeqEdit((old) =>
        old.filter((item) => item !== `message${id}`)
      );
      document.querySelector(`.stackMessage${id}`).remove();
    }
    if (type === "interval") {
      setNumberInterval((old) => old - 1);
      setElementsSeq((old) => old.filter((item) => item !== `interval${id}`));
      setElementsSeqEdit((old) =>
        old.filter((item) => item !== `interval${id}`)
      );
      document.querySelector(`.stackInterval${id}`).remove();
    }
    if (type === "img") {
      setNumberImg((old) => old - 1);
      setPreviewImg((old) => {
        setMedias((oldMedia) => {
          try {
            return oldMedia.filter(
              (mediaItem) =>
                mediaItem.name !==
                old.filter((item) => item.number === id)[0].name
            );
          } catch (e) {
            return oldMedia;
          }
        });
        return old.filter((item) => item.number !== id);
      });
      setElementsSeq((old) => old.filter((item) => item !== `img${id}`));
      setElementsSeqEdit((old) => old.filter((item) => item !== `img${id}`));
      document.querySelector(`.stackImg${id}`).remove();
    }
    if (type === "audio") {
      setNumberAudio((old) => old - 1);
      setPreviewAudios((old) => {
        setMedias((oldMedia) => {
          try {
            return oldMedia.filter(
              (mediaItem) =>
                mediaItem.name !==
                old.filter((item) => item.number === id)[0].name
            );
          } catch (e) {
            return oldMedia;
          }
        });
        return old.filter((item) => item.number !== id);
      });
      setElementsSeq((old) => old.filter((item) => item !== `audio${id}`));
      setElementsSeqEdit((old) => old.filter((item) => item !== `audio${id}`));
      document.querySelector(`.stackAudio${id}`).remove();
    }
    if (type === "video") {
      setNumberVideo((old) => old - 1);
      setPreviewVideos((old) => {
        setMedias((oldMedia) => {
          try {
            return oldMedia.filter(
              (mediaItem) =>
                mediaItem.name !==
                old.filter((item) => item.number === id)[0].name
            );
          } catch (e) {
            return oldMedia;
          }
        });
        return old.filter((item) => item.number !== id);
      });
      setElementsSeq((old) => old.filter((item) => item !== `video${id}`));
      setElementsSeqEdit((old) => old.filter((item) => item !== `video${id}`));
      document.querySelector(`.stackVideo${id}`).remove();
    }
    if (type === "document") {
      setNumberDocs((old) => old - 1);
      setPreviewDocs((old) => {
        setMedias((oldMedia) => {
          try {
            return oldMedia.filter(
              (mediaItem) =>
                mediaItem.name !==
                old.filter((item) => item.number === id)[0].name
            );
          } catch (e) {
            return oldMedia;
          }
        });
        return old.filter((item) => item.number !== id);
      });
      setElementsSeq((old) => old.filter((item) => item !== `document${id}`));
      setElementsSeqEdit((old) =>
        old.filter((item) => item !== `document${id}`)
      );
      document.querySelector(`.stackDocument${id}`).remove();
    }
    if (type === "button") {
      setNumberButton((old) => old - 1);
      setElementsSeq((old) => old.filter((item) => item !== `button${id}`));
      setElementsSeqEdit((old) => old.filter((item) => item !== `button${id}`));
      setElements((old) => old.filter((item) => !(item && item.type === "button" && item.number === id)));
      setButtonListFormState((prev) => {
        const next = { ...prev };
        delete next[`button${id}`];
        return next;
      });
    }
    if (type === "list") {
      setNumberList((old) => old - 1);
      setElementsSeq((old) => old.filter((item) => item !== `list${id}`));
      setElementsSeqEdit((old) => old.filter((item) => item !== `list${id}`));
      setElements((old) => old.filter((item) => !(item && item.type === "list" && item.number === id)));
      setButtonListFormState((prev) => {
        const next = { ...prev };
        delete next[`list${id}`];
        return next;
      });
    }
  };

  const moveElementDown = (id) => {
    setElementsSeq((old) => {
      const array = old;
      const index = array.indexOf(id);
      moveItemParaFrente(index);
      console.log("id", id);
      if (index !== -1 && index < array.length - 1) {
        // Verifica se o elemento foi encontrado no array e não está na última posição
        const novoArray = [...array]; // Cria uma cópia do array original
        const elementoMovido = novoArray.splice(index, 1)[0];
        novoArray.splice(index + 1, 0, elementoMovido);
        return novoArray;
      }
      return array;
    });
  };

  const moveElementUp = (id) => {
    setElementsSeq((old) => {
      const array = old;
      const index = array.indexOf(id);
      moveItemParaTras(index);

      if (index !== -1 && index > 0) {
        // Verifica se o elemento foi encontrado no array e não está na primeira posição
        const novoArray = [...array]; // Cria uma cópia do array original
        const elementoMovido = novoArray.splice(index, 1)[0];
        novoArray.splice(index - 1, 0, elementoMovido);
        return novoArray;
      }
      return array;
    });
  };

  function moveItemParaFrente(posicao) {
    setElements((old) => {
      const array = old;

      if (posicao >= 0 && posicao < array.length - 1) {
        const novoArray = [...array]; // Cria uma cópia do array original
        const elementoMovido = novoArray.splice(posicao, 1)[0];
        novoArray.splice(posicao + 1, 0, elementoMovido);
        return novoArray;
      }

      return array; // Retorna o array original se a movimentação não for possível
    });
  }

  function moveItemParaTras(posicao) {
    setElements((old) => {
      const array = old;
      if (posicao > 0 && posicao < array.length) {
        const novoArray = [...array]; // Cria uma cópia do array original
        const elementoMovido = novoArray.splice(posicao, 1)[0];
        novoArray.splice(posicao - 1, 0, elementoMovido);
        return novoArray;
      }

      return array; // Retorna o array original se a movimentação não for possível
    });
  }

  const handleChangeMediasImg = (e, number) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 2000000) {
      toast.error("Arquivo é muito grande! 2MB máximo");
      return;
    }
    const imgBlob = URL.createObjectURL(e.target.files[0]);
    // console.log("imgBlob", imgBlob);
    setPreviewImg((old) => [
      ...old,
      {
        number: number,
        url: imgBlob,
        name: e.target.files[0].name,
      },
    ]);
    const selectedMedias = Array.from(e.target.files);
    setMedias((old) => [...old, selectedMedias[0]]);

    document.querySelector(`.img${number}`).src = imgBlob;
    document.querySelector(`.btnImg${number}`).remove();
  };

  const handleChangeAudios = (e, number) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 5000000) {
      toast.error("Arquivo é muito grande! 5MB máximo");
      return;
    }

    const audioBlob = URL.createObjectURL(e.target.files[0]);
    setPreviewAudios((old) => [
      ...old,
      {
        number: number,
        url: audioBlob,
        name: e.target.files[0].name,
      },
    ]);

    const selectedMedias = Array.from(e.target.files);
    setMedias((old) => [...old, selectedMedias[0]]);

    document.querySelector(
      `.audio${number}`
    ).innerHTML = `<audio controls="controls">
    <source src="${audioBlob}" type="audio/mp3" />
    seu navegador não suporta HTML5
  </audio>`;
    document.querySelector(`.btnAudio${number}`).remove();
  };

  const handleChangeVideos = (e, number) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 20000000) {
      toast.error("Arquivo é muito grande! 20MB máximo");
      return;
    }
    const videoBlob = URL.createObjectURL(e.target.files[0]);
    setPreviewVideos((old) => [
      ...old,
      {
        number: number,
        url: videoBlob,
        name: e.target.files[0].name,
      },
    ]);

    var divConteudo = document.createElement("div");

    const selectedMedias = Array.from(e.target.files);
    setMedias((old) => [...old, selectedMedias[0]]);

    divConteudo.innerHTML = `<video controls="controls" style="width: 200px;">
    <source src="${videoBlob}" type="video/mp4" />
    seu navegador não suporta HTML5
  </video>`;

    document.querySelector(`.video${number}`).appendChild(divConteudo);
    document.querySelector(`.btnVideo${number}`).remove();
  };

  const imgLayout = (number, valueDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackImg${number}`}
        key={`stackImg${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "img")} />
        </Stack>
        <Typography textAlign={"center"}>Imagem</Typography>
        <Stack direction={"row"} justifyContent={"center"}>
          {/* COLOCAR AQUI */}
          <img
            src={
              valueDefault.length > 0
                ? `${process.env.REACT_APP_BACKEND_URL}/public/company${companyId}/flow/${valueDefault}`
                : ""
            }
            className={`img${number}`}
            style={{ width: "200px" }}
          />
        </Stack>
        {valueDefault.length === 0 && (
          <Button
            variant="contained"
            component="label"
            className={`btnImg${number}`}
          >
            Enviar imagem
            <input
              type="file"
              accept="image/png, image/jpg, image/jpeg"
              hidden
              onChange={(e) => handleChangeMediasImg(e, number)}
            />
          </Button>
        )}
      </Stack>
    );
  };

  const audioLayout = (number, valueDefault = "", valueRecordDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackAudio${number}`}
        key={`stackAudio${number}`}
      >
        <Stack
          sx={{ position: "absolute", right: 6 }}
          direction={"row"}
          gap={1}
        >
          {/* <KeyboardArrowUp
            onClick={() => moveElementUp(`audio${number}`)}
            sx={{ cursor: "pointer" }}
          />
          <KeyboardArrowDown
            onClick={() => moveElementDown(`audio${number}`)}
            sx={{ cursor: "pointer" }}
          /> */}
          <Delete
            sx={{ cursor: "pointer" }}
            onClick={() => deleteElementsTypeOne(number, "audio")}
          />
        </Stack>
        <Typography textAlign={"center"}>Audio</Typography>
        <div
          className={`audio${number}`}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {valueDefault.length > 0 && (
            <audio controls="controls">
              <source
                src={`${process.env.REACT_APP_BACKEND_URL}/public/company${companyId}/flow/${valueDefault}`}
                type="audio/mp3"
              />
              seu navegador não suporta HTML5
            </audio>
          )}
        </div>
        {valueDefault.length === 0 && (
          <Button
            variant="contained"
            component="label"
            className={`btnAudio${number}`}
          >
            Enviar audio
            <input
              type="file"
              accept="audio/ogg, audio/mp3, audio/opus"
              hidden
              onChange={(e) => handleChangeAudios(e, number)}
            />
          </Button>
        )}
        <Stack direction={"row"} justifyContent={"center"}>
          <Checkbox
            className={`checkaudio${number}`}
            defaultChecked={valueRecordDefault === "ok" ? false : true}
          />
          <Stack justifyContent={"center"}>
            <Typography>Enviar como audio gravado na hora</Typography>
          </Stack>
        </Stack>
      </Stack>
    );
  };

  const videoLayout = (number, valueDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackVideo${number}`}
        key={`stackVideo${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "video")} />
        </Stack>
        <Typography textAlign={"center"}>Video</Typography>
        <div
          className={`video${number}`}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {valueDefault.length > 0 && (
            <video controls="controls" style={{ width: "200px" }}>
              <source
                src={`${process.env.REACT_APP_BACKEND_URL}/public/company${companyId}/flow/${valueDefault}`}
                type="video/mp4"
              />
              seu navegador não suporta HTML5
            </video>
          )}
        </div>
        {valueDefault.length === 0 && (
          <Button
            variant="contained"
            component="label"
            className={`btnVideo${number}`}
          >
            Enviar video
            <input
              type="file"
              accept="video/mp4"
              hidden
              onChange={(e) => handleChangeVideos(e, number)}
            />
          </Button>
        )}
      </Stack>
    );
  };

  const messageLayout = (number, valueDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackMessage${number}`}
        key={`stackMessage${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "message")} />
        </Stack>
        <Typography textAlign={"center"}>Texto</Typography>
        <TextField
          label={"Mensagem"}
          defaultValue={valueDefault}
          multiline
          rows={7}
          className={`message${number}`}
          name="text"
          variant="outlined"
          margin="dense"
          style={{ width: "100%" }}
        />
      </Stack>
    );
  };

  const intervalLayout = (number, valueDefault = 0) => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackInterval${number}`}
        key={`stackInterval${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "interval")} />
        </Stack>
        <Typography textAlign={"center"}>Intervalo</Typography>
        <TextField
          label={"Tempo em segundos"}
          className={`interval${number}`}
          defaultValue={valueDefault}
          type="number"
          InputProps={{ inputProps: { min: 0, max: 120 } }}
          variant="outlined"
          margin="dense"
          style={{ width: "100%" }}
        />
      </Stack>
    );
  };

  const documentLayout = (number, valueDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackDocument${number}`}
        key={`stackDocument${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "document")} />
        </Stack>
        <Typography textAlign={"center"}>Documento</Typography>
        <div
          className={`document${number}`}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {valueDefault.length > 0 ? (
            <embed
              src={`${process.env.REACT_APP_BACKEND_URL}/public/company${companyId}/flow/${valueDefault}`}
              type="application/pdf"
              width="200px"
              height="200px"
            />
          ) : null}
        </div>
        {valueDefault.length === 0 && (
          <Button
            variant="contained"
            component="label"
            className={`btnDocument${number}`}
          >
            Enviar Documento
            <input
              type="file"
              accept=".doc,.docx,.pdf"
              hidden
              onChange={(e) => handleChangeDocuments(e, number)}
            />
          </Button>
        )}
      </Stack>
    );
  };

  const handleChangeDocuments = (e, number) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 10000000) {
      toast.error("Arquivo é muito grande! 10MB máximo");
      return;
    }

    const file = e.target.files[0];
    const documentBlob = URL.createObjectURL(file);

    // Verifica se o arquivo é PDF
    const isPDF = file.type === "application/pdf";

    setPreviewDocs((old) => [
      ...old,
      {
        number: number,
        url: documentBlob,
        name: file.name,
      },
    ]);

    const selectedMedias = Array.from(e.target.files);
    setMedias((old) => [...old, selectedMedias[0]]);

    if (isPDF) {
      document.querySelector(`.document${number}`).innerHTML = `
        <embed src="${documentBlob}" type="application/pdf" width="200px" height="200px" />
      `;
    } else {
      document.querySelector(`.document${number}`).innerHTML = `
        <a href="${documentBlob}" target="_blank" rel="noopener noreferrer">Visualizar Documento</a>
      `;
    }
    document.querySelector(`.btnDocument${number}`).remove();
  };

  const buttonLayout = (number, valueDefault = "", arrayOptionDefault = [], controlledState = null, onControlledChange = null) => {
    const key = `button${number}`;
    const isControlled = controlledState != null && typeof onControlledChange === "function";
    const opts = (arrayOptionDefault && arrayOptionDefault.length) ? arrayOptionDefault : [];
    const message = isControlled ? (controlledState.message ?? "") : valueDefault;
    const optValues = isControlled && controlledState.opts ? controlledState.opts : (opts.length ? opts.map((o) => (o?.value ?? "")) : [""]);
    const maxButtons = 3;
    const canAddMore = optValues.length < maxButtons;
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackButton${number}`}
        key={`stackButton${key}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "button")} />
        </Stack>
        <Typography textAlign={"center"}>Botão</Typography>
        <TextField
          label="Mensagem"
          value={isControlled ? message : undefined}
          defaultValue={isControlled ? undefined : valueDefault}
          onChange={isControlled ? (e) => onControlledChange({ ...controlledState, message: e.target.value }) : undefined}
          multiline
          rows={2}
          className={`buttonMessage${number}`}
          variant="outlined"
          margin="dense"
          fullWidth
        />
        <Typography variant="caption" sx={{ mt: 1 }}>Até 3 botões (título máx. 20 caracteres)</Typography>
        {optValues.map((val, idx) => (
          <TextField
            key={idx}
            label={`Botão ${idx + 1}`}
            value={isControlled ? (optValues[idx] ?? "") : undefined}
            defaultValue={isControlled ? undefined : (opts[idx]?.value ?? "")}
            onChange={isControlled ? (e) => {
              const next = [...(controlledState.opts || [""])];
              next[idx] = e.target.value;
              onControlledChange({ ...controlledState, opts: next });
            } : undefined}
            className={`buttonOpt${number}-${idx + 1}`}
            variant="outlined"
            margin="dense"
            size="small"
            inputProps={{ maxLength: 20 }}
          />
        ))}
        {canAddMore && isControlled && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<AddCircle />}
            onClick={() => onControlledChange({ ...controlledState, opts: [...(controlledState.opts || [""]), ""] })}
            sx={{ mt: 0.5 }}
          >
            Adicionar botão
          </Button>
        )}
      </Stack>
    );
  };

  const listLayout = (number, valueDefault = "", buttonTextDefault = "Escolha uma opção", sectionsDefault = [], controlledState = null, onControlledChange = null) => {
    const key = `list${number}`;
    const isControlled = controlledState != null && typeof onControlledChange === "function";
    const sec = (sectionsDefault && sectionsDefault[0]) ? sectionsDefault[0] : { title: "Opções", rows: [] };
    const rows = sec.rows || [];
    const emptyRow = () => ({ id: "", title: "" });
    const listRows = isControlled && controlledState.rows ? controlledState.rows : (rows.length ? rows : [emptyRow()]);
    const message = isControlled ? (controlledState.message ?? "") : valueDefault;
    const buttonText = isControlled ? (controlledState.buttonText ?? "Escolha uma opção") : buttonTextDefault;
    const sectionTitle = isControlled ? (controlledState.sectionTitle ?? "Opções") : sec.title;
    const maxRows = 10;
    const canAddMore = listRows.length < maxRows;
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackList${number}`}
        key={`stackList${key}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "list")} />
        </Stack>
        <Typography textAlign={"center"}>Lista</Typography>
        <TextField
          label="Texto da mensagem"
          value={isControlled ? message : undefined}
          defaultValue={isControlled ? undefined : valueDefault}
          onChange={isControlled ? (e) => onControlledChange({ ...controlledState, message: e.target.value }) : undefined}
          multiline
          rows={2}
          className={`listMessage${number}`}
          variant="outlined"
          margin="dense"
          fullWidth
        />
        <TextField
          label="Texto do botão que abre a lista"
          value={isControlled ? buttonText : undefined}
          defaultValue={isControlled ? undefined : buttonTextDefault}
          onChange={isControlled ? (e) => onControlledChange({ ...controlledState, buttonText: e.target.value }) : undefined}
          className={`listButtonText${number}`}
          variant="outlined"
          margin="dense"
          size="small"
          fullWidth
        />
        <TextField
          label="Título da seção"
          value={isControlled ? sectionTitle : undefined}
          defaultValue={isControlled ? undefined : sec.title}
          onChange={isControlled ? (e) => onControlledChange({ ...controlledState, sectionTitle: e.target.value }) : undefined}
          className={`listSectionTitle${number}`}
          variant="outlined"
          margin="dense"
          size="small"
          fullWidth
        />
        <Typography variant="caption" sx={{ mt: 1 }}>Itens (id e título, máx. 10)</Typography>
        {listRows.map((row, r) => (
          <Stack key={r} direction="row" spacing={1} sx={{ mt: 0.5 }} alignItems="center">
            <TextField
              label="ID"
              value={isControlled ? (listRows[r]?.id ?? "") : undefined}
              defaultValue={isControlled ? undefined : (row?.id ?? "")}
              onChange={isControlled ? (e) => {
                const next = [...(controlledState.rows || [emptyRow()])];
                next[r] = { ...(next[r] || emptyRow()), id: e.target.value };
                onControlledChange({ ...controlledState, rows: next });
              } : undefined}
              className={`listRowId${number}-${r}`}
              variant="outlined"
              size="small"
              style={{ width: 90 }}
            />
            <TextField
              label="Título"
              value={isControlled ? (listRows[r]?.title ?? "") : undefined}
              defaultValue={isControlled ? undefined : (row?.title ?? "")}
              onChange={isControlled ? (e) => {
                const next = [...(controlledState.rows || [emptyRow()])];
                next[r] = { ...(next[r] || emptyRow()), title: e.target.value };
                onControlledChange({ ...controlledState, rows: next });
              } : undefined}
              className={`listRowTitle${number}-${r}`}
              variant="outlined"
              size="small"
              style={{ flex: 1 }}
              inputProps={{ maxLength: 24 }}
            />
            {listRows.length > 1 && isControlled && (
              <IconButton size="small" onClick={() => {
                const next = controlledState.rows.filter((_, i) => i !== r);
                onControlledChange({ ...controlledState, rows: next.length ? next : [emptyRow()] });
              }} title="Remover item">
                <Delete fontSize="small" />
              </IconButton>
            )}
          </Stack>
        ))}
        {canAddMore && isControlled && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<AddCircle />}
            onClick={() => onControlledChange({ ...controlledState, rows: [...(controlledState.rows || [emptyRow()]), emptyRow()] })}
            sx={{ mt: 0.5 }}
          >
            Adicionar item
          </Button>
        )}
      </Stack>
    );
  };

  useEffect(() => {
    const localVariables = localStorage.getItem("variables");
    if (localVariables) {
      setVariables(JSON.parse(localVariables));
    }

    if (open === "edit") {
      setLabels({
        title: "Editar conteúdo",
        btn: "Salvar",
      });

      setElementsSeq(data.data.seq);

      setElementsSeqEdit(data.data.seq);
      setElementsEdit(data.data.elements);
      if (data) {
        const elementsEditLoc = data.data.elements;
        const sequence = data.data.seq;

        sequence.map((item) => {
          const itemNode = elementsEditLoc.filter(
            (inode) => inode.number === item
          )[0];
          if (itemNode.type === "message") {
            const numberLoc = parseInt(item.replace("message", ""));
            setElements((elm) => [
              ...elm,
              messageLayout(numberLoc, itemNode.value),
            ]);
            setNumberMessages((old) => {
              const arsOnly = sequence.filter((item) =>
                item.includes("message")
              );
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("message", ""))
              );
              setNumberMessagesLast(Math.max.apply(null, arrNumberMax) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "interval") {
            const numberLoc = parseInt(item.replace("interval", ""));
            setElements((elm) => [
              ...elm,
              intervalLayout(numberLoc, itemNode.value),
            ]);
            setNumberInterval((old) => {
              const arsOnly = sequence.filter((item) =>
                item.includes("interval")
              );
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("interval", ""))
              );
              setNumberIntervalLast(Math.max.apply(null, arrNumberMax) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "audio") {
            const numberLoc = parseInt(item.replace("audio", ""));
            setElements((elm) => [
              ...elm,
              audioLayout(
                numberLoc,
                itemNode.value,
                itemNode.record ? "" : "ok"
              ),
            ]);
            setNumberAudio((old) => {
              const arsOnly = sequence.filter((item) => item.includes("audio"));
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("audio", ""))
              );
              setNumberAudioLast(Math.max.apply(null, arrNumberMax) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "img") {
            const numberLoc = parseInt(item.replace("img", ""));
            setElements((elm) => [
              ...elm,
              imgLayout(numberLoc, itemNode.value),
            ]);
            setNumberImg((old) => {
              const arsOnly = sequence.filter((item) => item.includes("img"));
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("img", ""))
              );
              setNumberImgLast(Math.max.apply(null, arrNumberMax) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "video") {
            const numberLoc = parseInt(item.replace("video", ""));
            setElements((elm) => [
              ...elm,
              videoLayout(numberLoc, itemNode.value),
            ]);
            setNumberVideo((old) => {
              const arsOnly = sequence.filter((item) => item.includes("video"));
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("video", ""))
              );
              setNumberVideoLast(Math.max.apply(null, arrNumberMax) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "document") {
            const numberLoc = parseInt(item.replace("document", ""));
            setElements((elm) => [
              ...elm,
              documentLayout(numberLoc, itemNode.value),
            ]);
            setNumberDocs((old) => {
              const arsOnly = sequence.filter((item) =>
                item.includes("document")
              );
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("document", ""))
              );
              setNumberDocLast(Math.max.apply(null, arrNumberMax) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "button") {
            const numberLoc = parseInt(item.replace("button", ""));
            const key = `button${numberLoc}`;
            const opts = (itemNode.arrayOption || []).filter((o) => o != null).map((o) => (o?.value ?? "")).filter(Boolean);
            setButtonListFormState((prev) => ({
              ...prev,
              [key]: {
                message: itemNode.value ?? "",
                opts: opts.length ? opts : [""],
              },
            }));
            setElements((elm) => [...elm, { type: "button", number: numberLoc }]);
            setNumberButton((old) => {
              const arsOnly = sequence.filter((i) => i.includes("button"));
              const arrNumberMax = arsOnly.map((i) => parseInt(i.replace("button", "")));
              setNumberButtonLast(Math.max.apply(null, arrNumberMax.length ? arrNumberMax : [0]) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "list") {
            const numberLoc = parseInt(item.replace("list", ""));
            const key = `list${numberLoc}`;
            const sec = (itemNode.sections && itemNode.sections[0]) || { title: "Opções", rows: [] };
            const rows = (sec.rows && sec.rows.length) ? sec.rows : [{ id: "", title: "" }];
            setButtonListFormState((prev) => ({
              ...prev,
              [key]: {
                message: itemNode.value ?? "",
                buttonText: itemNode.buttonText ?? "Escolha uma opção",
                sectionTitle: sec.title ?? "Opções",
                rows,
              },
            }));
            setElements((elm) => [...elm, { type: "list", number: numberLoc }]);
            setNumberList((old) => {
              const arsOnly = sequence.filter((i) => i.includes("list"));
              const arrNumberMax = arsOnly.map((i) => parseInt(i.replace("list", "")));
              setNumberListLast(Math.max.apply(null, arrNumberMax.length ? arrNumberMax : [0]) + 1);
              return old + 1;
            });
          }
        });
      }
      setActiveModal(true);
    }
    if (open === "create") {
      setLabels({
        title: "Adicionar menu ao fluxo",
        btn: "Adicionar",
      });
      setTextDig();
      setArrayOption([]);
      setActiveModal(true);
    }
  }, [open]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = async () => {
    close(null);
    setActiveModal(false);
    setTimeout(() => {
      setMedias([]);
      setPreviewImg([]);
      setPreviewAudios([]);
      setPreviewVideos([]);
      setArrayOption([]);
      setElements([]);
      setElementsSeq([]);
      setElementsEdit([]);
      setElementsSeqEdit([]);
      setNumberMessages(0);
      setNumberMessagesLast(0);
      setNumberInterval(0);
      setNumberIntervalLast(0);
      setNumberAudio(0);
      setNumberAudioLast(0);
      setNumberVideo(0);
      setNumberVideoLast(0);
      setNumberImg(0);
      setNumberImgLast(0);
      setNumberButton(0);
      setNumberButtonLast(0);
      setNumberList(0);
      setNumberListLast(0);
      setButtonListFormState({});
    }, 500);
  };

  const verifyButtonsUpload = () => {
    const newArrImg = elementsSeq.filter((item) => item.includes("img"));
    const newArrAudio = elementsSeq.filter((item) => item.includes("audio"));
    const newArrVideo = elementsSeq.filter((item) => item.includes("video"));
    const newArrDocs = elementsSeq.filter((item) => item.includes("document"));

    for (let i = 0; i < numberImg; i++) {
      const imgVerify = document.querySelector(
        `.btn${capitalize(newArrImg[i])}`
      );
      if (imgVerify) {
        return true;
      }
    }
    for (let i = 0; i < numberAudio; i++) {
      const audioVerify = document.querySelector(
        `.btn${capitalize(newArrAudio[i])}`
      );
      if (audioVerify) {
        return true;
      }
    }
    for (let i = 0; i < numberVideo; i++) {
      const videoVerify = document.querySelector(
        `.btn${capitalize(newArrVideo[i])}`
      );
      if (videoVerify) {
        return true;
      }
    }
    for (let i = 0; i < numberDocs; i++) {
      const docVerify = document.querySelector(`.btnDocument${i}`);
      if (docVerify) {
        return true;
      }
    }
  };

  const handleSaveNode = async () => {
    if (open === "edit") {
      setLoading(true);
      const formData = new FormData();

      medias.forEach(async (media, idx) => {
        const file = media;

        if (!file) {
          return;
        }

        if (media?.type.split("/")[0] === "image") {
          formData.append("typeArch", "flow");
          formData.append("medias", file);
          formData.append("body", file.name);
        } else if (media?.type.split("/")[0] === "audio") {
          formData.append("typeArch", "flow");
          formData.append("medias", file);
          formData.append("body", file.name);
        } else if (media?.type.split("/")[0] === "video") {
          formData.append("typeArch", "flow");
          formData.append("medias", file);
          formData.append("body", file.name);
        } else if (
          media?.type.split("/")[0] === "application" ||
          media?.type.split("/")[1] === "document" ||
          media?.type.split("/")[1] === "pdf"
        ) {
          formData.append("typeArch", "flow");
          formData.append("medias", file);
          formData.append("body", file.name);
        } else {
          formData.append("typeArch", "flow");
          formData.append("medias", file);
          formData.append("body", file.name);
        }
      });

      // Sem mídia: salvar imediatamente (evita setTimeout que atrasa e pode perder estado)
      if (
        (numberAudio === 0 &&
          numberVideo === 0 &&
          numberImg === 0 &&
          numberDocs === 0) ||
        medias.length === 0
      ) {
        try {
          const elementsBuilt = handleElements(null);
          const mountData = { seq: elementsSeq, elements: elementsBuilt };
          const btnEl = elementsBuilt.find((e) => e.type === "button");
          const listEl = elementsBuilt.find((e) => e.type === "list");
          if (btnEl) console.log("[SingleBlock] Salvando botão arrayOption length:", btnEl.arrayOption?.length);
          if (listEl) console.log("[SingleBlock] Salvando lista sections length:", listEl.sections?.length);
          onUpdate({ ...data, data: mountData });
          toast.success("Conteúdo adicionada com sucesso!");
          handleClose();
          setLoading(false);
          return;
        } catch (e) {
          console.log("error1", e);
          setLoading(false);
          handleClose();
        }
        return;
      }

      setTimeout(async () => {
        const verify = verifyButtonsUpload();
        if (verify) {
          setLoading(false);
          return toast.error("Delete os cards vazios(Imagem, Audio e Video)");
        }

        await api
          .post("/flowbuilder/content", formData)
          .then(async (res) => {
            const mountData = {
              seq: elementsSeq,
              elements: handleElements(res.data),
            };
            onUpdate({
              ...data,
              data: mountData,
            });
            toast.success("Conteúdo adicionada com sucesso!");
            handleClose();
            setLoading(false);
          })
          .catch((error) => {
            console.log("error2", error);
            handleClose();
            setLoading(false);
          });
      }, 1500);
    } else if (open === "create") {
      setLoading(true);
      const formData = new FormData();

      medias.forEach(async (media, idx) => {
        const file = media;

        if (!file) {
          return;
        }

        if (media?.type.split("/")[0] === "image") {
          formData.append("typeArch", "flow");
          formData.append("medias", media);
          formData.append("body", media.name);
        } else if (media?.type.split("/")[0] === "audio") {
          formData.append("typeArch", "flow");
          formData.append("medias", media);
          formData.append("body", media.name);
        } else if (media?.type.split("/")[0] === "video") {
          formData.append("typeArch", "flow");
          formData.append("medias", media);
          formData.append("body", media.name);
        } else if (
          media?.type.split("/")[0] === "application" ||
          media?.type.split("/")[1] === "document" ||
          media?.type.split("/")[1] === "pdf"
        ) {
          formData.append("typeArch", "flow");
          formData.append("medias", media);
          formData.append("body", media.name);
        } else {
          formData.append("typeArch", "flow");
          formData.append("medias", media);
          formData.append("body", media.name);
        }
      });

      // Sem mídia: salvar imediatamente para não perder estado de botão/lista
      if (
        numberAudio === 0 &&
        numberVideo === 0 &&
        numberImg === 0 &&
        numberDocs === 0
      ) {
        try {
          const elementsBuilt = handleElements(null);
          const mountData = { seq: elementsSeq, elements: elementsBuilt };
          onSave({ ...mountData });
          toast.success("Conteúdo adicionada com sucesso!");
          handleClose();
          setLoading(false);
          return;
        } catch (e) {
          console.log("error3", e);
          setLoading(false);
          handleClose();
        }
        return;
      }

      setTimeout(async () => {
        const verify = verifyButtonsUpload();
        if (verify) {
          setLoading(false);
          return toast.error("Delete os cards vazios(Imagem, Audio e Video)");
        }
        await api
          .post("/flowbuilder/content", formData)
          .then((res) => {
            const mountData = {
              seq: elementsSeq,
              elements: handleElements(res.data),
            };
            onSave({
              ...mountData,
            });
            toast.success("Conteúdo adicionada com sucesso!");
            handleClose();
            setLoading(false);
          })
          .catch((error) => {
            console.log("error4", error);
            setLoading(false);
            handleClose();
          });
      }, 1500);
    }
  };

  const scrollToBottom = (className) => {
    const element = document.querySelector(className);
    element.scrollTop = element.scrollHeight;
  };

  const variableFormatter = (item) => {
    return "{{" + item + "}}";
  };

  return (
    <div>
      <Dialog open={activeModal} maxWidth="lg" fullWidth={true} scroll="paper">
        {!loading && (
          <DialogTitle id="form-dialog-title">
            Adicionar conteúdo ao fluxo
          </DialogTitle>
        )}
        <Stack>
          <Stack
            className="body-card"
            style={{
              gap: "8px",
              padding: "16px",
              overflow: "auto",
              height: "70vh",
              scrollBehavior: "smooth",
              display: loading && "none",
            }}
          >
            {elements.map((item, idx) => {
              if (item && item.type === "button") {
                const key = `button${item.number}`;
                const st = buttonListFormState[key] ?? { message: "", opts: [""] };
                return (
                  <React.Fragment key={key}>
                    {buttonLayout(item.number, "", [], st, (next) =>
                      setButtonListFormStateAndRef(key, next)
                    )}
                  </React.Fragment>
                );
              }
              if (item && item.type === "list") {
                const key = `list${item.number}`;
                const st = buttonListFormState[key] ?? {
                  message: "",
                  buttonText: "Escolha uma opção",
                  sectionTitle: "Opções",
                  rows: [{ id: "", title: "" }],
                };
                return (
                  <React.Fragment key={key}>
                    {listLayout(item.number, "", "Escolha uma opção", [], st, (next) =>
                      setButtonListFormStateAndRef(key, next)
                    )}
                  </React.Fragment>
                );
              }
              return <React.Fragment key={idx}>{item}</React.Fragment>;
            })}
            <Stack direction={"row"} gap={1}>
              {/* Texto */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setElements((old) => [
                    ...old,
                    messageLayout(numberMessagesLast),
                  ]);
                  setNumberMessages((old) => {
                    setElementsSeq((oldEleme) => [
                      ...oldEleme,
                      `message${numberMessagesLast}`,
                    ]);
                    return old + 1;
                  });
                  setNumberMessagesLast((old) => old + 1);
                  setTimeout(() => {
                    scrollToBottom(".body-card");
                  }, 100);
                }}
              >
                <Message
                  sx={{
                    width: "16px",
                    height: "16px",
                    marginRight: "4px",
                  }}
                />
                Texto
              </Button>
              {/* Intervalo */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setElements((old) => [
                    ...old,
                    intervalLayout(numberIntervalLast),
                  ]);
                  setNumberInterval((old) => {
                    setElementsSeq((oldEleme) => [
                      ...oldEleme,
                      `interval${numberIntervalLast}`,
                    ]);
                    return old + 1;
                  });
                  setNumberIntervalLast((old) => old + 1);
                  setTimeout(() => {
                    scrollToBottom(".body-card");
                  }, 100);
                }}
              >
                <AccessTime
                  sx={{
                    width: "16px",
                    height: "16px",
                    marginRight: "4px",
                  }}
                />
                Intervalo
              </Button>
              {/* Imagem */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setElements((old) => [...old, imgLayout(numberImgLast)]);
                  setNumberImg((old) => {
                    setElementsSeq((oldEleme) => [
                      ...oldEleme,
                      `img${numberImgLast}`,
                    ]);
                    return old + 1;
                  });
                  setNumberImgLast((old) => old + 1);
                  setTimeout(() => {
                    scrollToBottom(".body-card");
                  }, 100);
                }}
              >
                <Image
                  sx={{
                    width: "16px",
                    height: "16px",
                    marginRight: "4px",
                  }}
                />
                Imagem
              </Button>
              {/* Audio */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setElements((old) => [...old, audioLayout(numberAudioLast)]);
                  setNumberAudio((old) => {
                    setElementsSeq((oldEleme) => [
                      ...oldEleme,
                      `audio${numberAudioLast}`,
                    ]);
                    return old + 1;
                  });
                  setNumberAudioLast((old) => old + 1);
                  setTimeout(() => {
                    scrollToBottom(".body-card");
                  }, 100);
                }}
              >
                <MicNone
                  sx={{
                    width: "16px",
                    height: "16px",
                    marginRight: "4px",
                  }}
                />
                Audio
              </Button>
              {/* Video */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setElements((old) => [...old, videoLayout(numberVideoLast)]);
                  setNumberVideo((old) => {
                    setElementsSeq((oldEleme) => [
                      ...oldEleme,
                      `video${numberVideoLast}`,
                    ]);
                    return old + 1;
                  });
                  setNumberVideoLast((old) => old + 1);
                  setTimeout(() => {
                    scrollToBottom(".body-card");
                  }, 100);
                }}
              >
                <Videocam
                  sx={{
                    width: "16px",
                    height: "16px",
                    marginRight: "4px",
                  }}
                />
                Video
              </Button>
              {/* Documento */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setElements((old) => [...old, documentLayout(numberDocLast)]);
                  setNumberDocs((old) => {
                    setElementsSeq((oldEleme) => [
                      ...oldEleme,
                      `document${numberDocLast}`,
                    ]);
                    return old + 1;
                  });
                  setNumberDocLast((old) => old + 1);
                  setTimeout(() => {
                    scrollToBottom(".body-card");
                  }, 100);
                }}
              >
              <InsertDriveFile
                sx={{
                  width: "16px",
                  height: "16px",
                  marginRight: "4px",
                }}
              />
                Documento
              </Button>
            </Stack>
            <Box style={{ width: "100%", textAlign: "center" }}>
              <div className="shadow- py-2 font-bold bg-blue-900 rounded text-white">
                Variáveis
              </div>
              {variables && (
                <div className="w-full  max-h-full overflow-y-auto space-y-2 py-2">
                  {variables.map((item) => (
                    <div className="rounded border-2 border-dashed border-zinc-800">
                      <p className="text-zinc-600">{variableFormatter(item)}</p>
                    </div>
                  ))}
                </div>
              )}
            </Box>
          </Stack>

          <DialogActions>
            <Button
              onClick={handleClose}
              color="secondary"
              variant="outlined"
              style={{ display: loading && "none" }}
            >
              {i18n.t("contactModal.buttons.cancel")}
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              onClick={() => handleSaveNode()}
              style={{ display: loading && "none" }}
            >
              {`${labels.btn}`}
            </Button>
          </DialogActions>
        </Stack>
        {loading && (
          <Stack
            style={{
              gap: "8px",
              padding: "16px",
              height: "70vh",
              alignSelf: "center",
              justifyContent: "center",
            }}
          >
            <Stack>
              <Typography>
                Subindo os arquivos e criando o conteúdo...
              </Typography>
              <Stack style={{ alignSelf: "center", marginTop: "12px" }}>
                <CircularProgress />
              </Stack>
            </Stack>
          </Stack>
        )}
      </Dialog>
    </div>
  );
};

export default FlowBuilderSingleBlockModal;
